<template>
  <v-container>

    <!-- Barra de control -->
    <v-row justify="center" class="mb-10">
      <v-col cols="12" sm="10" md="8">
        <v-card class="control-bar" elevation="2">
          <v-row align="center" no-gutters>

            <!-- Buscador -->
            <v-col cols="12" md="9">
              <v-autocomplete
                v-model="jugadorSeleccionado"
                :items="jugadoresOrdenados"
                item-text="NOMBRE"
                item-value="NOMBRE"
                label="Buscar jugador"
                prepend-inner-icon="mdi-account-search"
                outlined
                dense
                clearable
                return-object
                hide-details
              />
            </v-col>

            <!-- Refresh -->
            <v-col
              cols="12"
              md="3"
              class="d-flex justify-end"
            >
              <v-btn
                color="primary"
                class="refresh-btn"
                :loading="loading"
                @click="refreshData"
              >
                <v-icon left>mdi-refresh</v-icon>
                Actualizar
              </v-btn>
            </v-col>

          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Lista de jugadores -->
    <v-row>
      <v-col
        v-for="player in jugadoresFiltrados"
        :key="player.NOMBRE"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card
          class="player-card"
          elevation="6"
          @click="goInfoPla(player)"
        >
          <v-card-text class="text-center pa-6">

            <v-avatar size="120" class="mb-5">
              <v-img :src="player.FOTO" />
            </v-avatar>

            <div class="text-h5 font-weight-bold mb-1">
              {{ player.NOMBRE }}
            </div>

            <div class="subtitle-1 grey--text mb-4">
              {{ player.POSICIONES }}
            </div>

            <div class="universities-badge">
              {{ player.UNIVERSIDADES }} universidades
            </div>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
const { GoogleSpreadsheet } = require('google-spreadsheet')

export default {
  name: 'Main',

  data () {
    return {
      jugadores: [],
      universidades: [],
      jugadores_copia: [],
      universidades_copia: [],
      jugadorSeleccionado: null,
      loading: false
    }
  },

  mounted () {
    // 1️⃣ Intentamos cargar desde route (navegación interna)
    if (this.$route.params.jugadores && this.$route.params.universidades) {
      this.jugadores = this.$route.params.jugadores
      this.universidades = this.$route.params.universidades
      this.jugadores_copia = this.jugadores
      this.universidades_copia = this.universidades
    } else {
      // 2️⃣ Si no hay params → cargamos desde Google Sheets
      this.cargarDesdeSheets()
    }
  },

  computed: {
    jugadoresOrdenados () {
      return [...this.jugadores].sort((a, b) =>
        a.NOMBRE.localeCompare(b.NOMBRE)
      )
    },

    jugadoresFiltrados () {
      if (!this.jugadorSeleccionado) return this.jugadoresOrdenados
      return [this.jugadorSeleccionado]
    }
  },

  methods: {
    async cargarDesdeSheets () {
      const doc = new GoogleSpreadsheet(
        '1aCjEh_gJ6XgIVaL1LwBO3rPhw4R7xl5uZ1keirRol94'
      )

      const creds = require('../../public/service_account.json')

      await doc.useServiceAccountAuth(creds)
      await doc.loadInfo()

      // Sheet 0 → Universidades
      const sheetUni = doc.sheetsByIndex[0]
      const rowsUni = await sheetUni.getRows()
      this.universidades = rowsUni

      // Sheet 1 → Jugadores
      const sheetPla = doc.sheetsByIndex[1]
      const rowsPla = await sheetPla.getRows()

      // Quitamos jugadores con STATUS = 1 (como hacías tú)
      this.jugadores = rowsPla.filter(j => j.STATUS != 1)

      // Copias limpias
      this.jugadores_copia = this.jugadores
      this.universidades_copia = this.universidades

      // Calculamos universidades por jugador
      this.calcularUniversidadesPorJugador()
    },

     async refreshData () {
      this.loading = true

      // Guardamos selección actual
      const nombreSeleccionado = this.jugadorSeleccionado?.NOMBRE || null

      // Limpiamos estado
      this.jugadorSeleccionado = null

      // Volvemos a cargar desde Excel
      await this.cargarDesdeSheets()

      // Restauramos selección si sigue existiendo
      if (nombreSeleccionado) {
        const encontrado = this.jugadores.find(
          j => j.NOMBRE === nombreSeleccionado
        )
        if (encontrado) {
          this.jugadorSeleccionado = encontrado
        }
      }

      this.loading = false
    },

    calcularUniversidadesPorJugador () {
      this.jugadores.forEach(player => {
        let count = 0

        this.universidades.forEach(uni => {
          const A = ['D1', 'D2', 'NAIA', 'JUCO']
          const B = ['D2', 'NAIA', 'JUCO']
          const C = ['NAIA', 'JUCO']
          const D = ['JUCO']

          const niveles = {
            A, B, C, D
          }

          const budgetMap = {
            A: ['A', 'B', 'C', 'D'],
            B: ['B', 'C', 'D'],
            C: ['C', 'D'],
            D: ['D']
          }

          if (
            niveles[player.NIVEL]?.includes(uni.DIVISIÓN) &&
            budgetMap[player.BUDGET]?.includes(uni.BUDGET)
          ) {
            const posPlayer = (player.POSICIONES || '').split(',').map(p => p.trim())
            const posUni = (uni.POSICIONES || '').split(',').map(p => p.trim())

            if (posPlayer.some(p => posUni.includes(p))) {
              count++
            }
          }
        })

        player.UNIVERSIDADES = count
      })
    },

    goInfoPla (player) {
      this.$router.push({
        name: 'InfoPla',
        params: {
          jugadores: player,
          universidades: this.universidades,
          jugadores_copia: this.jugadores_copia,
          universidades_copia: this.universidades_copia
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.player-card {
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.25s ease;
  height: 100%;
}

.player-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
}

.universities-badge {
  display: inline-block;
  padding: 8px 18px;
  background: linear-gradient(135deg, #0061ef, #1e88e5);
  color: #fff;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 700;
}

.v-autocomplete {
  background: #fff;
}

.search-refresh {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  flex: 1;
}

.control-bar {
  padding: 14px 18px;
  border-radius: 16px;
  background: #ffffff;
}

.refresh-btn {
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
}

</style>
